import PlatinumVenueCard from './PlatinumVenueCard';

export default PlatinumVenueCard;
